import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_USER,
  DELETE_USER,
  GET_USERS,
  SET_USER_LIST_VIEW,
  UPDATE_USER
} from '../actions';

const initialUserListViewState = {
  error             : <string>'',
  loading           : <boolean>false,
  message           : <string>'',
  selectedUser      : <string>'',
  user              : <any>{},
  userDetailsLoading: <boolean>false
};

export function userListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_USER:
      const match = state.find(user => action.payload.user && user.email === action.payload.user.email);
      return !match
        ? [ ...state, action.payload.user ].sort(sortUsers)
        : state;
    case DELETE_USER:
      return state.filter(user => user.email !== action.payload.email);
    case GET_USERS:
      return [ ...action.payload.users ].sort(sortUsers);
    case UPDATE_USER:
      return state.map(user => {
        return user.email === action.payload.user.email
          ? action.payload.user
          : user;
      });
    default:
      return state;
  }
}

export function userListViewReducer(state = initialUserListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialUserListViewState);
    case SET_USER_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

function sortUsers(user1, user2): number {
  const username1 = user1.email.trim().toLowerCase();
  const username2 = user2.email.trim().toLowerCase();

  if (username1 < username2) return -1;
  if (username1 > username2) return 1;
  return 0;
}

export const userReducers = combineReducers({
  userList: userListReducer,
  userListView: userListViewReducer
});



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/users.ts